export default __webpack_public_path__ + "static/media/Victoria Typewriter Bold.ad18a001.ttf";